import styled from 'styled-components';
export var LogoBlock = styled.div.withConfig({
  displayName: "partials__LogoBlock",
  componentId: "sc-s2yc3j-0"
})(["svg{width:100px;height:auto;}"]);